const toggle=document.querySelector('.menu-toggle');
const nav=document.querySelector('#main-nav');
if(toggle&&nav){toggle.addEventListener('click',()=>{const open=toggle.getAttribute('aria-expanded')==='true';toggle.setAttribute('aria-expanded',String(!open));nav.classList.toggle('open',!open)});nav.querySelectorAll('a').forEach(link=>link.addEventListener('click',()=>{toggle.setAttribute('aria-expanded','false');nav.classList.remove('open')}))}

const leadForm=document.querySelector('#kbrc-lead-form');
const leadStatus=document.querySelector('#lead-form-status');
const successModal=document.querySelector('#lead-success');
if(leadForm&&leadStatus&&successModal){
  const submitButton=leadForm.querySelector('.lead-submit');
  const submitLabel=submitButton.querySelector('span');
  const closeButtons=successModal.querySelectorAll('.success-close,.success-done');
  let priorFocus=null;
  const closeSuccess=()=>{successModal.hidden=true;document.body.classList.remove('modal-open');if(priorFocus)priorFocus.focus()};
  const openSuccess=()=>{priorFocus=document.activeElement;successModal.hidden=false;document.body.classList.add('modal-open');successModal.querySelector('.success-close').focus()};
  closeButtons.forEach(button=>button.addEventListener('click',closeSuccess));
  successModal.addEventListener('click',event=>{if(event.target===successModal)closeSuccess()});
  document.addEventListener('keydown',event=>{if(event.key==='Escape'&&!successModal.hidden)closeSuccess()});
  leadForm.addEventListener('submit',async event=>{
    event.preventDefault();
    leadStatus.textContent='';
    if(!leadForm.checkValidity()){leadForm.reportValidity();return}
    submitButton.disabled=true;
    submitLabel.textContent='Sending…';
    try{
      const response=await fetch(`https://formsubmit.co/ajax/info@kingdombuilders.construction`,{method:'POST',headers:{Accept:'application/json'},body:new FormData(leadForm)});
      const result=await response.json().catch(()=>({}));
      if(!response.ok||result.success===false)throw new Error('Submission was not accepted');
      leadForm.reset();
      openSuccess();
    }catch(error){
      leadStatus.innerHTML='We could not send the form just now. Please call <a href="tel:+19432123223">(943) 212-3223</a> or email <a href="mailto:info@kingdombuilders.construction">info@kingdombuilders.construction</a>.';
    }finally{
      submitButton.disabled=false;
      submitLabel.textContent='Send my request';
    }
  });
}

document.querySelectorAll('[data-review-rotator]').forEach(rotator=>{
  const reviews=[...rotator.querySelectorAll('article')];
  const controls=[...rotator.querySelectorAll('.google-review-controls button')];
  if(reviews.length<2)return;
  let active=0;
  let timer;
  const show=index=>{
    active=(index+reviews.length)%reviews.length;
    reviews.forEach((review,i)=>review.classList.toggle('is-active',i===active));
    controls.forEach((control,i)=>{control.classList.toggle('is-active',i===active);control.setAttribute('aria-pressed',String(i===active))});
  };
  const start=()=>{if(matchMedia('(prefers-reduced-motion: reduce)').matches)return;clearInterval(timer);timer=setInterval(()=>show(active+1),6500)};
  controls.forEach((control,index)=>control.addEventListener('click',()=>{show(index);start()}));
  rotator.addEventListener('mouseenter',()=>clearInterval(timer));
  rotator.addEventListener('mouseleave',start);
  rotator.addEventListener('focusin',()=>clearInterval(timer));
  rotator.addEventListener('focusout',start);
  start();
});

const referralForm=document.querySelector('#kbrc-referral-form');
const referralStatus=document.querySelector('#referral-form-status');
const referralSuccess=document.querySelector('#referral-success');
if(referralForm&&referralStatus&&referralSuccess){
  const submitButton=referralForm.querySelector('.lead-submit');
  const submitLabel=submitButton.querySelector('span');
  const closeButtons=referralSuccess.querySelectorAll('.success-close,.success-done');
  const intentInputs=[...referralForm.querySelectorAll('input[name="Participation Type"]')];
  let priorFocus=null;
  const updateLabel=()=>{const selected=intentInputs.find(input=>input.checked);submitLabel.textContent=selected?.value==='Submit a Referral'?'Submit my referral':'Join the program'};
  const closeSuccess=()=>{referralSuccess.hidden=true;document.body.classList.remove('modal-open');if(priorFocus)priorFocus.focus()};
  const openSuccess=()=>{priorFocus=document.activeElement;referralSuccess.hidden=false;document.body.classList.add('modal-open');referralSuccess.querySelector('.success-close').focus()};
  intentInputs.forEach(input=>input.addEventListener('change',updateLabel));
  closeButtons.forEach(button=>button.addEventListener('click',closeSuccess));
  referralSuccess.addEventListener('click',event=>{if(event.target===referralSuccess)closeSuccess()});
  document.addEventListener('keydown',event=>{if(event.key==='Escape'&&!referralSuccess.hidden)closeSuccess()});
  referralForm.addEventListener('submit',async event=>{
    event.preventDefault();
    referralStatus.textContent='';
    if(!referralForm.checkValidity()){referralForm.reportValidity();return}
    submitButton.disabled=true;submitLabel.textContent='Sending…';
    try{
      const response=await fetch('https://formsubmit.co/ajax/info@kingdombuilders.construction',{method:'POST',headers:{Accept:'application/json'},body:new FormData(referralForm)});
      const result=await response.json().catch(()=>({}));
      if(!response.ok||result.success===false)throw new Error('Submission was not accepted');
      referralForm.reset();updateLabel();openSuccess();
    }catch(error){
      referralStatus.innerHTML='We could not send the form just now. Please call <a href="tel:+19432123223">(943) 212-3223</a> or email <a href="mailto:info@kingdombuilders.construction">info@kingdombuilders.construction</a>.';
    }finally{submitButton.disabled=false;updateLabel()}
  });
}
